import { Track } from "livekit-client";
import { buildAudioPublishPreset } from "../ui/conference-settings-modal/conference-settings.constants";

/**
 * Применяет выбранный битрейт к уже опубликованному микрофону без переподключения к комнате:
 * publishDefaults учитываются только при подключении, поэтому меняем maxBitrate напрямую
 * в параметрах RTCRtpSender.
 * Возвращает false, если sender ещё недоступен (микрофон не опубликован).
 */
export const applyMicrophoneBitrate = async (localParticipant, selectedAudioBitrate) => {
  const sender = localParticipant?.getTrackPublication(Track.Source.Microphone)?.track?.sender;

  if (!sender) {
    return false;
  }

  const { maxBitrate } = buildAudioPublishPreset(selectedAudioBitrate);
  const parameters = sender.getParameters();

  if (!parameters.encodings?.length) {
    parameters.encodings = [{}];
  }

  parameters.encodings[0].maxBitrate = maxBitrate;

  try {
    await sender.setParameters(parameters);
    return true;
  } catch {
    return false;
  }
};
